import { Replace } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";
import { useQueryClient } from "@tanstack/react-query";

import { useCloseBreakoutSession } from "../api/breakout-session";

export function CloseRoomsDialog() {
  const [isCloseRoomsModalOpen, setIsCloseRoomsModalOpen] = useState(false);
  const sessionId = useVidyoStore((store) => store.sessionId);
  const queryClient = useQueryClient();
  const { mutateAsync: closeBreakoutSession, isPending } =
    useCloseBreakoutSession({
      onMutate: () => {
        queryClient.setQueryData(["breakout-sessions", sessionId], () => {
          return [];
        });
      },
      onSuccess: () => {
        queryClient.refetchQueries({
          queryKey: ["breakout-sessions", sessionId],
        });
      },
    });

  const handleCloseBreakoutSessions = async () => {
    await closeBreakoutSession({ sessionId });
    setIsCloseRoomsModalOpen(false);
  };

  return (
    <Dialog
      open={isCloseRoomsModalOpen}
      onOpenChange={setIsCloseRoomsModalOpen}
    >
      <DialogTrigger asChild>
        <Button variant="ghost" className="h-auto flex-col">
          <span className="mb-2 text-sm font-medium">Close Rooms</span>
          <Replace className="size-6 text-[#F97066]" />
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-xl" aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>Close all breakout rooms?</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <p className="text-sm text-muted-foreground">
            Everyone will be returned to the main room in{" "}
            <span className="font-semibold">15</span> seconds
          </p>
        </DialogBody>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => setIsCloseRoomsModalOpen(false)}
            disabled={isPending}
          >
            Cancel
          </Button>
          <Button
            onClick={handleCloseBreakoutSessions}
            disabled={isPending}
            isLoading={isPending}
            isAnimated
          >
            Close Rooms
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
